import { EMPTY_ITEM_RIGHTS_COLLECTION } from "../../../../Global/Base/Rights/RightTypes";
import { invariant } from "../../../../Global/Base/Utils/AssertUtils";
import { GenericControl } from "../Controls/Control";
import { GenericPageTab } from "../Controls/GenericPage";
import { GenericPages } from "../Controls/GenericPages";
import { NodeAction } from "../XGControls/Actions/NodeAction";
import { ToolbarGroups } from "./ToolbarGroups";
import { ToolbarPage } from "./ToolbarPage";
/**Kontejner pro zalozky v menu (ToolBaru)*/
export class ToolbarPages extends GenericPages {
    //#region Methods
    /**Prida zalozku*/
    public override addPage(tabName: string, key: string, locKey: string, element?: HTMLDivElement, ctrlID?: string, priority?: number): ToolbarPage {
        // K 3. prosinci 2020 se addPage nikdy nevolá se zadaným elementem. Alespoň to tak vypadá.
        // Pro jistotu jsem kód nemazal, ale pouze tu dal invariant.
        // - Pokud to tu nebude padat, pak invariant smaž a refaktoruj odděláním parametru "element".
        // - Pokud to spadne, pak:
        //        - zjisti, odkud se to volá a přidej to do jsdoc
        //        - a nahraď EMPTY_ITEM_RIGHTS_COLLECTION za řádné načtení práv z "element"
        invariant(!element, "Element is not expected.");

        const header: GenericPageTab = new GenericPageTab(tabName, locKey);

        this.pageTabs.push(header);

        //Nastaveni poradi podle priority akce
        let position = this.pages.length;
        if (priority !== undefined) {
            for (let i = 0; i < this.pages.length; i++) {
                if ((this.pages[i] as ToolbarPage).priority > priority) {
                    position = i;
                    break;
                }
            }
        }

        if (position < this.pages.length)
            this._tabStrip.insertBefore(header.element, this._tabStrip.childNodes[position] as HTMLElement);
        else
            this._tabStrip.appendChild(header.element);

        let pageDiv: HTMLDivElement;

        if (element)
            pageDiv = element;
        else
            pageDiv = document.createElement("div");

        this._pageContainer.appendChild(pageDiv);
        this._pageContainer.classList.add("tabPageContainer");

        const page = new ToolbarPage({
            element: pageDiv,
            originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION,
            header,
            ctrlID,
            priority,
        });

        this.pages.push(page);

        header.tabSelected.add((sender: GenericPageTab) => {
            this.selectPage(sender);
            this.selectPage(page);
        });

        page.ctrlID = ctrlID;

        page.initPage();

        if (key == "default") {
            page.header.element.classList.add("active");
        }

        page.groups = new ToolbarGroups({ element: page.element, originalRightsDefinition: page.originalRightsDefinition });

        return page;
    }

    /**Prida skupinu*/
    public addGroup(group: NodeAction, page: ToolbarPage): boolean {
        if (page == null)
            page = this.addOrFindPage(group.masterNode, group.masterNode, null, group.masterNode);

        if (page != null) {
            page.addOrFindGroup(group.locKey, group.toMenu, group.ctrlID, group.priority);

            return true; //todo: MV je potreba promyslet, pokud neuspeje nebo to spadne, tak by to asi melo vratit false, navic se v metode AddOrFindPage budou vytvaret neuplne page, takze taky doladit
        }

        throw "Pozadovanou stranku se nepodarilo vytvorit!!!";
    }

    /**Prida nebo vrati stranku*/
    public addOrFindPage(tabName: string, key: string, locKey: string, ctrlID: string): ToolbarPage {
        const page: ToolbarPage = this._findPage(ctrlID);

        if (page != null)
            return page;
        else
            return this.addPage(tabName, key, locKey, null, ctrlID);
    }

    /**Najde existujici stranku*/
    private _findPage(ctrlID: string): ToolbarPage {
        for (let i: number = 0; i < this.pages.length; i++) {
            const page: ToolbarPage = (this.pages[i] as ToolbarPage);
            if (page.ctrlID == ctrlID) {
                return page;
            }
        }

        return null;
    }

    //async
    //public FindMasterNode(ctrlID: string): Control[] {
    //    var page: ToolbarPage = this.findPage(ctrlID);

    //    var controls: Promise<Control[]>[] = [];

    //    if (page != null) {
    //        controls.push(Promise.resolve([page]));
    //        return controls;
    //    }

    //    for (var i: number = 0; i < this.Pages.length; i++) {
    //        page = (<ToolbarPage>this.Pages[i]);

    //        controls = controls.concat(page.FindMasterNode(ctrlID));
    //    }

    //    return controls;
    //}

    /**Najde masternode*/
    public findMasterNode(ctrlID: string): GenericControl[] {
        let page: ToolbarPage = this._findPage(ctrlID);

        let controls: GenericControl[] = [];

        if (page != null) {
            controls.push(page);
            return controls;
        }

        for (let i: number = 0; i < this.pages.length; i++) {
            page = (this.pages[i] as ToolbarPage);

            controls = controls.concat(page.findMasterNode(ctrlID));
        }

        return controls;
    }

    /**
     *
     */
    public sortByPriority(): void {
        this.pages.forEach((page) => {
            (page as ToolbarPage).groups.sortByPriority();
        });
    }

    //#endregion Methods
}
